import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // About submenu routes
  {
    path: '/about/overview',
    name: 'AboutOverview',
    component: () => import('../views/about/Overview.vue')
  },
  {
    path: '/about/hangzhou',
    name: 'AboutHangzhou',
    component: () => import('../views/about/Hangzhou.vue')
  },
  {
    path: '/about/shanghai',
    name: 'AboutShanghai',
    component: () => import('../views/about/Shanghai.vue')
  },
  {
    path: '/about/wuhan',
    name: 'AboutWuhan',
    component: () => import('../views/about/Wuhan.vue')
  },
  // Services submenu routes
  {
    path: '/services/expert',
    name: 'ServicesExpert',
    component: () => import('../views/services/Expert.vue')
  },
  {
    path: '/services/data',
    name: 'ServicesData',
    component: () => import('../views/services/Data.vue')
  },
  {
    path: '/services/roadshow',
    name: 'ServicesRoadshow',
    component: () => import('../views/services/Roadshow.vue')
  },
  {
    path: '/services/sitevisit',
    name: 'ServicesSiteVisit',
    component: () => import('../views/services/SiteVisit.vue')
  },
  {
    path: '/services/research',
    name: 'ServicesResearch',
    component: () => import('../views/services/Research.vue')
  },
  // Clients submenu routes
  {
    path: '/clients/enterprise',
    name: 'ClientsEnterprise',
    component: () => import('../views/clients/Enterprise.vue')
  },
  {
    path: '/clients/professional',
    name: 'ClientsProfessional',
    component: () => import('../views/clients/Professional.vue')
  },
  {
    path: '/clients/financial',
    name: 'ClientsFinancial',
    component: () => import('../views/clients/Financial.vue')
  },
  // Advantages submenu routes
  {
    path: '/advantages/overview',
    name: 'AdvantagesOverview',
    component: () => import('../views/advantages/Overview.vue')
  },
  // Expert Agreement page
  {
    path: '/expert-agreement',
    name: 'ExpertAgreement',
    component: () => import('../views/ExpertAgreement.vue')
  },
  // Compliance Framework page
  {
    path: '/compliance-framework',
    name: 'ComplianceFramework',
    component: () => import('../views/ComplianceFramework.vue')
  },
  // Expert Introduction page
  {
    path: '/expert-introduction',
    name: 'ExpertIntroduction',
    component: () => import('../views/ExpertIntroduction.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
